module.exports = __webpack_public_path__ + "img/Bonbon.92ef6ebb.svg";